import React from 'react';
import useSelector from '@redux/typedHooks';
import { cloudinaryAttachment } from '@utils/imageUrl';
import DownloadArrowIcon from '@components/icons/DownloadArrow';
import * as S from './CtaFileLink.styles';

interface CtaFileLinkSerializerProps {
  value: {
    text: string;
    filename?: string;
    file: {
      publicId: string;
      srcSet?: {
        file?: string;
      };
      version?: number;
    };
  };
}

export const CtaFileLinkBlock = ({ value: { text, file, filename } }: CtaFileLinkSerializerProps) => {
  const application = useSelector((state) => state.application);
  const downloadUrl = file && file.publicId && cloudinaryAttachment(file.publicId, application, filename);
  return (
    (downloadUrl && (
      <S.StyledButton href={downloadUrl} variant="outlined">
        {text} <DownloadArrowIcon />
      </S.StyledButton>
    )) ||
    null
  );
};
